import type { MessageSchema } from './en';

export const ru: MessageSchema = {
  app: {
    title: 'Stream Dashboard',
    skip: 'К содержимому',
    nav: { live: 'Лента', connection: 'Соединение', settings: 'Настройки' },
    navLabel: 'Основная',
  },
  status: {
    connected: 'Подключено',
    reconnecting: 'Переподключение',
    offline: 'Нет связи',
    stale: 'Данные устарели',
    announce: 'Соединение: {status}',
  },
  quality: {
    good: 'Норма',
    suspect: 'Сомнительно',
    bad: 'Ошибка',
    all: 'Любое качество',
  },
  playback: {
    legend: 'Воспроизведение',
    live: 'Live',
    '1x': '1×',
    '10x': '10×',
    '100x': '100×',
    step: 'Шаг',
    stepOnce: 'Следующая партия',
    pause: 'Пауза',
    resume: 'Продолжить',
    rate: 'Событий в секунду',
    position: '{position} из {total} партий',
  },
  feed: {
    title: 'Лента',
    search: 'Фильтр по имени',
    searchPlaceholder: 'например, TMP-00042',
    qualityFilter: 'Качество',
    table: 'Датчики',
    columns: {
      name: 'Имя',
      kind: 'Тип',
      value: 'Значение',
      trend: 'Тренд',
      quality: 'Качество',
      updated: 'Обновлено',
      updates: 'Обновлений',
    },
    sortBy: 'Сортировать по «{column}»',
    noReading: 'Показаний ещё нет',
    trendUp: 'Растёт',
    trendDown: 'Падает',
    trendFlat: 'Без изменений',
    empty: 'Под фильтр не подходит ни один датчик.',
    open: 'Открыть {name}',
  },
  stats: {
    eventsPerSecond: 'Событий/с',
    commitsPerSecond: 'Коммитов/с',
    lastBatch: 'Последняя партия',
    maxBatch: 'Крупнейшая партия',
    dropped: 'Потеряно',
    rendered: 'Строк в DOM',
    total: 'Датчиков',
    rejected: 'Отклонено',
    help: 'Один коммит на кадр анимации — сколько бы событий ни пришло между кадрами.',
  },
  kind: {
    temperature: 'Температура',
    pressure: 'Давление',
    flow: 'Расход',
    vibration: 'Вибрация',
    humidity: 'Влажность',
  },
  instrument: {
    back: 'Назад к ленте',
    previous: 'Предыдущий датчик',
    next: 'Следующий датчик',
    current: 'Текущее показание',
    lastUpdate: 'Последнее обновление',
    updates: 'Получено показаний',
    history: 'Последние {count} зафиксированных значений, по одному на кадр',
    chart: '{name}: {count} точек, от {min} до {max} {unit}, последнее {last} {unit}',
    chartEmpty: '{name}: показаний ещё нет',
    notFound: 'Датчика {id} нет во флоте из {count}.',
    navLabel: 'Соседние датчики',
  },
  connection: {
    title: 'Соединение',
    transport: 'Транспорт',
    transports: { worker: 'Web Worker', replay: 'Запись', none: 'Нет' },
    mode: 'Режим',
    lastMessage: 'Последние данные',
    never: 'ещё не было',
    ago: '{seconds} с назад',
    faults: 'Внесение сбоев',
    faultsHelp:
      'Только в режиме Live. «Зависание» оставляет соединение открытым и молчащим; «Обрыв» закрывает его.',
    stall: 'Зависание',
    drop: 'Обрыв',
    clear: 'Снять сбой',
    reconnect: 'Переподключить',
    recording: 'Запись',
    recordingHelp:
      'Сохраните кадры по мере прихода, затем воспроизведите их или приложите к баг-репорту.',
    startRecording: 'Начать запись',
    stopRecording: 'Остановить и скачать',
    recordingFrames: 'Записано кадров: {count}',
    load: 'Загрузить запись',
    loadHelp:
      'JSON-файл, сохранённый с этой страницы. После загрузки воспроизведение переключается на 1×.',
    loadError: 'Этот файл — не запись: {message}',
    loaded: 'Загружено {count} кадров из {name}',
    normalizer: 'Нормализатор',
    accepted: 'Принято',
    malformed: 'Испорчено',
    duplicate: 'Дубликаты',
    stale: 'Устаревшие',
    reordered: 'Не по порядку',
    gaps: 'Пропуски',
    unknownInstrument: 'Неизвестный датчик',
  },
  settings: {
    title: 'Настройки',
    appearance: 'Оформление',
    theme: { legend: 'Тема', system: 'Системная', light: 'Светлая', dark: 'Тёмная' },
    language: { legend: 'Язык', en: 'English', ru: 'Русский' },
    fleet: 'Флот',
    instruments: 'Датчиков',
    instrumentsHelp: 'Смена флота сбрасывает все показания.',
    rate: 'Событий в секунду',
    seed: 'Seed',
    seedHelp: 'Один seed — один и тот же поток. Измените, чтобы получить другой флот.',
    dirtyWire: 'Грязный канал',
    dirtyWireHelp:
      'Добавлять дубликаты, перестановки, NaN и неизвестные коды качества, чтобы нормализатору было что отклонять.',
    apply: 'Применить настройки флота',
  },
  notFound: { title: 'Страница не найдена', body: 'По этому адресу ничего нет.' },
};
